<template>

  <v-overlay :absolute="absolute" :value="overlay">
    <v-progress-circular
      :size="70"
      :width="7"
      indeterminate
      style="color:#1565C0;"

    ></v-progress-circular>
  </v-overlay>

</template>
<style>
</style>
<script>
  export default {
    data: () => ({
      overlay: true,
      absolute: true,
    }),
  }
</script>
